import async from 'components/template/Async';
import { RouteInfoType } from 'types/common/routes';

export const RevenueShare = async(() => import('pages/marketplace/itemSales/RevenueShare'));
export const RevenueDetail = async(() => import('pages/marketplace/itemSales/RevenueDetail'));
export const ReferralShare = async(() => import('pages/marketplace/referral/ReferralShare'));
export const ReferralDetail = async(() => import('pages/marketplace/referral/ReferralDetail'));

const REVENUE_SHARE_PATH = '/marketplace/revenue-share';
export const ITEM_SALES_PATH = `${REVENUE_SHARE_PATH}/item-sales`;
export const REFERRAL_PATH = `${REVENUE_SHARE_PATH}/referral`;

export const ItemSalesRoutes: RouteInfoType[] = [
  {
    id: 'item-sales',
    name: 'Item Sales',
    path: `${ITEM_SALES_PATH}/detail/:tab`,
    component: RevenueDetail,
  },
];

export const ReferralRoutes: RouteInfoType[] = [
  {
    id: 'referral',
    name: 'Referral',
    path: `${REFERRAL_PATH}/detail/`,
    component: ReferralDetail,
  },
];
